import viewsClient from '../templates/index.js';
import { setTemplatesResources } from '@bonusmap/shared_ui/library';
setTemplatesResources(viewsClient as any);
export {
    setTemplatesResources,
    templateExistsInMemory,
    getFirstTemplateValidId,
    templateRenderString,
    templateParse,
    templateParseToElement,
    templateParseToSelector,
    templateParseMultipleIds,
    templateParseToElementMultipleIds,
    templateParseToSelectorMultipleIds,
    type NunjucksFilterCallback,
    type NunjucksEnvCallbacks,
    type TemplateSearchContext
} from '@bonusmap/shared_ui/library';
